import React from "react";
import { Spin } from "antd";

export default function PageLoading() {
  return (
    <Spin spinning={true}>
    </Spin>
  );
}
